import React from "react";
import { styled } from "styled-components";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import PageSyncCal from "../../components/Layout/PageSyncCal";
import Heading from "../../components/Layout/Heading";
import { OuterContainerStyles } from "../../components/Layout/Typography";
import Button from "../../components/Layout/Button";
import BasicDatePicker from "../../components/DatePicker/BasicDatePicker";
import BasicTimePicker from "../../components/TimePicker";

// --- Modern Styled Components ---

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05); /* Subtle modern shadow */
`;

const FormBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
`;

const FormRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;

  /* Responsive behavior for smaller screens */
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

const Label = styled.label`
  color: #374151; /* Modern dark grey */
  font-size: 14px;
  font-weight: 600;
  margin: 0;
`;

const StyledTextArea = styled.textarea`
  width: 100%;
  min-height: 100px;
  padding: 12px 16px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  color: #1f2937;
  font-family: inherit;
  resize: vertical;
  outline: none;
  transition: all 0.2s ease-in-out;
  box-sizing: border-box;

  &::placeholder {
    color: #9ca3af;
  }

  &:focus {
    border-color: #3b82f6; /* Modern blue focus ring */
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }
`;

const CheckboxGrid = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  gap: 74px;
  margin-top: 8px;
  background-color: #f9fafb;
  padding: 16px 24px;
  border-radius: 8px;
  border: 1px solid #f3f4f6;
  overflow-x: auto;

  /* Text ko break hone se rokne ke liye */
  & > label {
    white-space: nowrap;
    margin-right: 0;
  }
`;

const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  padding: 16px 24px;
  border-top: 1px solid #e5e7eb;
  background-color: #f9fafb;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`;

function MessageTicker() {
  return (
    <div style={{ width: "100%", overflow: "hidden" }}>
      <PageSyncCal />
      <Heading title="Message Ticker" />

      <OuterContainerStyles marginTop="24px" marginBottom="24px">
        <FormContainer>
          <FormBody>
            {/* Ticker Text Section */}
            <FormGroup>
              <Label>Ticker Text1</Label>
              <StyledTextArea placeholder="Add Ticker Text Here" />
            </FormGroup>

            {/* Date and Time (From) Section */}
            <FormRow>
              <FormGroup>
                <Label>Date(From)</Label>
                <BasicDatePicker useDefaultBorders />
              </FormGroup>
              <FormGroup>
                <Label>Time</Label>
                <BasicTimePicker />
              </FormGroup>
            </FormRow>

            {/* Date and Time (To) Section */}
            <FormRow>
              <FormGroup>
                <Label>Date(To)</Label>
                <BasicDatePicker useDefaultBorders />
              </FormGroup>
              <FormGroup>
                <Label>Time</Label>
                <BasicTimePicker />
              </FormGroup>
            </FormRow>

            {/* Show In Section */}
            <FormGroup>
              <Label>Show In (Logins)</Label>
              <CheckboxGrid>
                <FormControlLabel control={<Checkbox />} label="Area " />
                <FormControlLabel control={<Checkbox />} label="Cluster " />
                <FormControlLabel control={<Checkbox />} label="Zone " />
                <FormControlLabel control={<Checkbox />} label="Region " />
                <FormControlLabel control={<Checkbox />} label="Chapter " />
                <FormControlLabel control={<Checkbox />} label="District " />
              </CheckboxGrid>
            </FormGroup>
          </FormBody>

          {/* Form Actions (Buttons) */}
          <ActionsContainer>
            <Button cancel>Cancel</Button>
            <Button>Submit</Button>
          </ActionsContainer>
        </FormContainer>
      </OuterContainerStyles>
    </div>
  );
}

export default MessageTicker;
